import store from "../../Redux/store";
import { setNfts, countNfts } from "./Nfts.reducer";

export function saveListNfts(records) {
  store.dispatch(setNfts(records));
}

export function saveCountNfts(count) {
  store.dispatch(countNfts(count));
}